import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-forest" data-id="element-178">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-ink leading-relaxed bg-white p-6 rounded-2xl border border-beige shadow-sm" data-id="element-179">
            Domingo a las 11 de la noche. Mañana tienes clase de Historia de
            México. Y todavía estás buscando cómo explicar la diferencia entre
            los mexicas y los toltecas, o cómo presentar la Conquista sin
            simplificarla demasiado ni perder a tus alumnos en el camino.
            <br data-id="element-180" />
            <br data-id="element-181" />
            <span className="text-terracotta font-bold" data-id="element-182">
              No es tu culpa.
            </span>{' '}
            Es que llevas años peleando con libros de texto desactualizados,
            programas que no se conectan entre sí y recursos pensados para otros
            contextos que después tienes que reescribir entero antes de poder
            usarlos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183">
          <h3 className="text-xl font-bold text-ink mb-8 text-center" data-id="element-184">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-185">
            {['Noches en vela buscando cómo hacer que 40,000 años de historia de México tengan sentido en una clase de 50 minutos', 'Clases improvisadas porque no encontraste un material claro, completo y listo para usar a tiempo', 'Alumnos desconectados que sienten que la historia es una lista interminable de fechas y nombres que no tiene nada que ver con ellos', 'Silencios incómodos cuando un alumno pregunta la diferencia real entre el Período Clásico y el Posclásico y no tienes una respuesta ordenada a mano', 'Fines de semana perdidos armando actividades, evaluaciones y proyectos desde cero, una y otra vez, cada ciclo escolar', 'La culpa de sentir que tus alumnos merecen más profundidad y más conexión con lo que estudian, pero el tiempo no te alcanza'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl border border-urgent/20 shadow-sm" data-id="element-186">
                <span className="text-urgent mt-1" data-id="element-187">🔴</span>
                <span className="text-warmgray font-medium" data-id="element-188">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-beige" data-id="element-189">
            <p className="text-2xl font-serif font-bold text-terracotta" data-id="element-190">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tienes.
              Ahora te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-forest font-bold" data-id="element-191">
              Planifica todo tu año hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}